import { WarmingUpCollections } from '@wg/wows-entities/const';
import CrewVoiceButton from '~/components/CrewVoiceButton/CrewVoiceButton';
import { ManagerData } from '~/core/ManagerData';

interface ICrewVoiceButtonContainer {
    className?: string;
    primaryItem: IBundleEntity;
}

const CrewVoiceButtonContainer = ({ className, primaryItem }: ICrewVoiceButtonContainer) => {
    if (!primaryItem.identifier) {
        return;
    }

    const crewData = ManagerData.getData(WarmingUpCollections.crews, primaryItem.identifier, true);

    if (!crewData?.hasSampleVo) {
        return null;
    }

    return (
        <div className={className}>
            <CrewVoiceButton crewId={primaryItem?.identifier} />
        </div>
    );
};

export default CrewVoiceButtonContainer;
